export default __webpack_public_path__ + "static/03-74dd67996f604d64a51b3103bbf6be8f.mp4";